import { setSelectAll, setSelectedStudents, setCheckBoxState, postLogOfflineAttendance } from 'actions/schedule'
import { Button, Checkbox, Spin, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PageDataLoader from 'components/pageDataLoader'
import { Api } from 'services'
import UserAvatar from 'components/userAvatar'
const { Text } = Typography
const checkCircle = require("../../../../Assets/scheduleAttendance/CheckCircle.svg").default
const editIcon = require("../../../../Assets/scheduleAttendance/ic-edit.svg").default
const closeCircle = require("../../../../Assets/scheduleAttendance/CloseCircle.svg").default
const emptyGhost = require("../../../../Assets/schedule/Group 10647.svg").default

const ScheduleStudentCard = ({ url, name, rollNo, id, setSelectedStudents, isSelected, disable }) => {

  const selectHandler = () => {
    setSelectedStudents(id)
  }

  return (
    <div className='schedule-studentCard' onClick={disable ? null : selectHandler} style={{ border: isSelected ? '1px solid #6BDB9E' : null, backgroundColor: isSelected ? '#E9FCF5' : null, cursor: disable ? 'default' : 'pointer' }}>
      <div style={{ alignSelf: 'center', margin: '0px 20px' }}>
        <UserAvatar
          size={60}
          shape="circle"
          name={name}
          img={url && url !== 'default.png' ? `${Api._s3_url}${url}` : ''}
        />
      </div>
      <div className='schedule-studentCard-details' style={{ flex: 1, minWidth: 0, paddingRight: '45px' }}>
        <Text
          ellipsis={{ tooltip: name }}
          style={{ fontWeight: 'bold', fontSize: '16px', display: 'block' }}
        >
          {name}
        </Text>
        <div style={{ fontSize: '14px', color: '#636363' }}>Roll no. {rollNo}</div>
      </div>
      {isSelected ? <div className='schedule-studentCard-svg'>
        <img src={checkCircle}></img>
      </div>
        :
        null}

    </div>
  )
}



const StudentCardsDisplay = ({ data, setSelectedStudents, selectedStudents, setSelectAll, setCheckBoxState, checkboxState, postLogOfflineAttendance, submitHandler, attendanceIndicator, presentStudents, studentListLoading }) => {

  const [attendanceMarked, setAttendanceMarked] = useState(attendanceIndicator)

  useEffect(() => {
    setAttendanceMarked(attendanceIndicator)
  }, [attendanceIndicator])

  // Deduplicate incoming student data by `studentId` to avoid rendering same student twice
  const uniqueData = (() => {
    if (!data) return []
    const map = new Map()
    data.forEach((item) => {
      if (!item) return
      // derive a stable key for a student record - try several common fields
      const key = (item.studentId !== undefined && item.studentId !== null) ? item.studentId :
        (item.id !== undefined && item.id !== null) ? item.id :
          (item.student && item.student.id !== undefined) ? item.student.id :
            (item.student_id !== undefined && item.student_id !== null) ? item.student_id : null
      const strKey = key !== null ? String(key) : null
      // fallback: if no id-like field, use combination of name+rollNo to dedupe
      const fallbackKey = strKey || `${item.name || ''}-${item.rollNo || ''}-${item.image || ''}`
      if (!map.has(fallbackKey)) {
        map.set(fallbackKey, item)
      }
    })
    return Array.from(map.values())
  })()

  const presentList = []
  const absentList = []

  uniqueData.forEach((item) => {
    if (selectedStudents?.[item?.studentId] === true) {
      presentList.push(item)
    } else {
      absentList.push(item)
    }
  })

  const selectAllHandler = () => {
    setSelectAll()
    setCheckBoxState(!checkboxState)
  }

  const editHandler = () => {
    setAttendanceMarked(false)
  }

  return (
    <div style={{ width: '100%', paddingTop: '12px' }}>
      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      <PageDataLoader visible={studentListLoading} />
      {!attendanceMarked ? (
        <>
          {uniqueData.length === 0 && !studentListLoading ? (
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '80px', height: '100%' }}>
              <img src={emptyGhost} alt="no-data" style={{ width: '230px', height: 'auto', marginBottom: '24px' }} />
              <p style={{ color: '#AEAEAE', fontSize: '16px', family: 'Roboto' }}>No Students found for this class.</p>
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <div>Select those who are <img src={checkCircle} alt="Check Circle" style={{ margin: '0 8px' }} /> <span style={{ color: '#28DF99' }}>PRESENT</span></div>
                <div>
                  <Button style={{ backgroundColor: '#594099', borderRadius: '20px', color: '#fff', minWidth: '120px' }} onClick={submitHandler}>SUBMIT</Button>
                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>ALL STUDENTS({uniqueData?.length ? uniqueData.length : '0'})</div>
                {presentList?.length >= 1 || absentList?.length >= 1 ?
                  <div>
                    <Checkbox onChange={(e) => { e.stopPropagation(); selectAllHandler(); }} checked={checkboxState} />
                    <span onClick={selectAllHandler} style={{ marginLeft: '10px', cursor: 'pointer' }}>{checkboxState ? 'UNSELECT ALL' : 'SELECT ALL'}</span>
                  </div>
                  : null
                }
              </div>
              {studentListLoading ? (
                <div style={{ paddingBottom: '100px' }} />
              ) : (
                <div style={{ paddingBottom: '20px', marginTop: '10px' }} className="no-scrollbar">
                  <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px', flexWrap: 'wrap' }}>
                    {uniqueData?.map((item) => (
                      <ScheduleStudentCard
                        key={item?.studentId}
                        url={item?.image}
                        name={item?.name}
                        rollNo={item?.rollNo}
                        id={item?.studentId}
                        isSelected={selectedStudents[item?.studentId] !== undefined && selectedStudents[item?.studentId]}
                        setSelectedStudents={setSelectedStudents}
                      />
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {uniqueData.length === 0 && !studentListLoading ? (
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '80px', height: '100%' }}>
              <img src={emptyGhost} alt="no-data" style={{ width: '230px', height: 'auto', marginBottom: '24px' }} />
              <p style={{ color: '#AEAEAE', fontSize: '16px', family: 'Roboto' }}>No Students found for this class.</p>
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                {presentList?.length >= 1 && (
                  <div><img src={checkCircle} alt="Check Circle" style={{ marginRight: '8px' }} /> <span style={{ color: '#28DF99' }}>PRESENT</span></div>
                )}
                <div>
                  <div onClick={editHandler} style={{ border: '1px solid #1089FF', padding: '1px 20px', borderRadius: '20px', cursor: 'pointer' }}><img src={editIcon} alt="Edit Icon" /> <span style={{ color: '#1089FF', fontSize: '12px', fontWeight: 'bold' }}>EDIT</span></div>
                </div>
              </div>
              {studentListLoading ? (
                <div style={{ paddingBottom: '100px' }} />
              ) : (
                <>
                  {presentList?.length >= 1 && (
                    <div style={{ paddingBottom: '20px', marginTop: '10px' }} className="no-scrollbar">
                      <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px', flexWrap: 'wrap' }}>
                        {presentList?.map((item) => (
                          <ScheduleStudentCard
                            key={item?.studentId}
                            url={item?.image}
                            name={item?.name}
                            rollNo={item?.rollNo}
                            id={item?.studentId}
                            disable={true}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                  {absentList?.length >= 1 && (
                    <>
                      <div style={{ marginBottom: '10px' }}>
                        <div><img src={closeCircle} alt="Close Circle" style={{ marginRight: '8px' }} /> <span style={{ color: '#FF414D' }}>ABSENT</span></div>
                      </div>
                      <div style={{ paddingBottom: '10px', marginTop: '10px' }} className="no-scrollbar">
                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '12px', flexWrap: 'wrap' }}>
                          {absentList?.map((item) => (
                            <ScheduleStudentCard
                              key={item?.studentId}
                              url={item?.image}
                              name={item?.name}
                              rollNo={item?.rollNo}
                              id={item?.studentId}
                              disable={true}
                            />
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}

    </div>
  );
}

const mapStateToProps = state => {
  const { selectedStudents, checkboxState, studentListLoading } = state.schedule
  return { selectedStudents, checkboxState, studentListLoading }
}
const mapDispatchToProps = (dispatch) => ({
  setSelectedStudents: (id) => dispatch(setSelectedStudents(id)),
  setSelectAll: (id, value) => dispatch(setSelectAll(id, value)),
  setCheckBoxState: (bool) => dispatch(setCheckBoxState(bool))
})

export default connect(mapStateToProps, mapDispatchToProps)(StudentCardsDisplay);